import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Inject, inject, APP_INITIALIZER, NgModule } from '@angular/core';
import * as i1$1 from '@ngrx/store';
import { createAction, props, createReducer, on, createFeatureSelector, createSelector, Store, StoreModule } from '@ngrx/store';
import * as i3 from '@ngrx/effects';
import { Actions, createEffect, ofType, EffectsModule } from '@ngrx/effects';
import { createEntityAdapter } from '@ngrx/entity';
import { throwError, switchMap, catchError as catchError$1, of, withLatestFrom, map, filter, mergeMap } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as i2 from '@panamax/app-state';
import { retryBackoff } from '@panamax/app-state';
import * as i1 from '@angular/common/http';
import { ItemType } from '@usf/mpp-types';
import { v4 } from 'uuid';

const MPP_KEY = 'menuProfitPro';
const RECIPE_KEY = 'recipeProfitPro';
const MPP_PRODUCT_KEY = 'mppProduct';

const NGRX_TOOLS_LIB_CONFIG = new InjectionToken('NGRX_TOOLS_LIB_CONFIG');

const MPP_ACTIONS = {
    clickMPPEntryPoint: createAction('[NGRXTrace - MPP] navigate to MPP landing', props()),
    enterLanding: createAction('[NGRXTrace - MPP] setup subMenu for landing page', props()),
    enterRecipe: createAction('[NGRXTrace - MPP] setup subMenu for recipe page', props()),
    visitingMPPRootPage: createAction('[NgRx - MPP] visiting MPP root page', props()),
    getRecipes: createAction('[NGRXTrace - MPP] get recipes', props()),
    deleteRecipes: createAction('[NGRXTrace - MPP] delete recipes', props()),
    archiveRecipes: createAction('[NGRXTrace - MPP] archive recipes', props()),
    createRecipe: createAction('[NGRXTrace - MPP] create recipe', props()),
    copyRecipes: createAction('[NGRXTrace - MPP] copy recipes', props()),
    uploadImage: createAction('[NGRXTrace - MPP] upload recipe profile image', props()),
    getMyChanges: createAction('[NGRXTrace - MPP] send timestamp to check changes', props()),
    enterRecipeDetails: createAction('[NGRXTrace - MPP] enter recipe details', props()),
};

var MppPages;
(function (MppPages) {
    MppPages["recipes"] = "recipes";
    MppPages["dashboard"] = "dashboard";
})(MppPages || (MppPages = {}));

/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-shadow */
const mppAdapter = createEntityAdapter({
    selectId: (mpp) => mpp.id,
});
const aiTile = {
    buttonText: 'i18n.menuProfitPro.aiTile.buttonText',
    title: 'i18n.menuProfitPro.aiTile.title',
    subTitle: 'i18n.menuProfitPro.aiTile.subTitle',
};
const imageTiles = [
    {
        label: 'i18n.menuProfitPro.imageTiles.descriptors.recipes',
        title: 'i18n.menuProfitPro.imageTiles.recipes',
        imageUrl: '/assets/images/mpp_recipe.svg',
        tag: 'recipe-tile',
        disabled: false,
        goTo: MppPages.recipes,
    },
    {
        label: 'i18n.menuProfitPro.imageTiles.descriptors.create',
        title: 'i18n.menuProfitPro.imageTiles.create',
        imageUrl: '/assets/images/Add.svg',
        tag: 'create-new-tile',
        disabled: false,
        goTo: '',
    },
    {
        label: 'i18n.menuProfitPro.imageTiles.descriptors.comeSoon',
        title: 'i18n.menuProfitPro.imageTiles.menu',
        imageUrl: '/assets/images/mpp_menu.svg',
        tag: 'menu-tile',
        disabled: true,
        // chnage to menu item path when page is made
        goTo: '',
    },
    {
        label: 'i18n.menuProfitPro.imageTiles.descriptors.comeSoon',
        title: 'i18n.menuProfitPro.imageTiles.event',
        imageUrl: '/assets/images/mpp_event.svg',
        tag: 'event-tile',
        disabled: true,
        // chnage to events path when page is made
        goTo: '',
    },
];
const initialMPPState$1 = mppAdapter.getInitialState({
    loaded: false,
    aiTile: aiTile,
    images: imageTiles,
    subMenuItems: [],
});
// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
const _MppReducer = createReducer(initialMPPState$1, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
on(MPP_ACTIONS.enterLanding, (state, { tracking }) => ({
    ...state,
    subMenuItems: setupSubMenu(MppPages.dashboard),
})), 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
on(MPP_ACTIONS.enterRecipe, (state, { tracking }) => ({
    ...state,
    subMenuItems: setupSubMenu(MppPages.recipes),
})), on(MPP_ACTIONS.visitingMPPRootPage, (state, { lastVisited }) => ({
    ...state,
    lastVisited,
})));
const setupSubMenu = (page) => {
    return [
        {
            label: 'i18n.menuProfitPro.links.dashboard',
            tag: MppPages.dashboard,
            isSelected: page === MppPages.dashboard,
            goTo: '',
        },
        {
            label: 'i18n.menuProfitPro.links.recipes',
            tag: MppPages.recipes,
            isSelected: page === MppPages.recipes,
            goTo: MppPages.recipes,
        },
    ];
};
function mppReducer(state, action) {
    return _MppReducer(state, action);
}

/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-shadow */
class ToolsHttpClientService {
    config;
    http;
    constructor(config, http) {
        this.config = config;
        this.http = http;
    }
    get(path, watermark) {
        const url = watermark
            ? `${this.config.apiUrl}/${path}?watermark=${watermark}`
            : `${this.config.apiUrl}/${path}`;
        return this.http.get(url).pipe(retryBackoff({
            initialInterval: 1000,
            maxRetries: 1,
            maxInterval: 1100,
            shouldRetry: () => true,
        }), catchError(this.handleError));
    }
    getWithBody(path, body) {
        const url = `${this.config.apiUrl}/${path}`;
        return this.http
            .request('GET', url, { body })
            .pipe(retryBackoff({
            initialInterval: 1000,
            maxRetries: 1,
            maxInterval: 1100,
            shouldRetry: () => true,
        }), catchError(this.handleError));
    }
    post(path, body) {
        const url = `${this.config.apiUrl}/${path}`;
        return this.http.post(url, body).pipe(retryBackoff({
            initialInterval: 1000,
            maxRetries: 1,
            maxInterval: 1100,
            shouldRetry: () => true,
        }), catchError(this.handleError));
    }
    put(path, body) {
        const url = `${this.config.apiUrl}/${path}`;
        return this.http.put(url, body).pipe(retryBackoff({
            initialInterval: 1000,
            maxRetries: 1,
            maxInterval: 1100,
            shouldRetry: () => true,
        }), catchError(this.handleError));
    }
    delete(path, body) {
        const url = `${this.config.apiUrl}/${path}`;
        return this.http.delete(url, body).pipe(retryBackoff({
            initialInterval: 1000,
            maxRetries: 1,
            maxInterval: 1100,
            shouldRetry: () => true,
        }), catchError(this.handleError));
    }
    handleError(error) {
        return throwError(error);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ToolsHttpClientService, deps: [{ token: NGRX_TOOLS_LIB_CONFIG }, { token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ToolsHttpClientService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ToolsHttpClientService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [NGRX_TOOLS_LIB_CONFIG]
                }] }, { type: i1.HttpClient }]; } });

/* eslint-disable @typescript-eslint/no-explicit-any */
const RECIPE_ACTIONS = {
    getRecipes: createAction('[NgRx - MPP] get recipes', props()),
    getRecipesSuccess: createAction('[[NgRx - MPP] get recipes success', props()),
    getRecipesFailure: createAction('[NgRx - MPP] get recipes fail', props()),
    selectRecipe: createAction('[NgRx - MPP] select recipe card', props()),
    selectMultiple: createAction('[NgRx - MPP] select multiple recipe cards', props()),
    deselectMultiple: createAction('[NgRx - MPP] deselect multiple recipe cards', props()),
    selectRecipeForPageView: createAction('[NgRx - MPP] select recipe for page view', props()),
    resetRecipes: createAction('[NgRx - mpp] reset recipes'),
    resetSelections: createAction('[NgRx - mpp] reset selections'),
    deleteRecipes: createAction('[NgRx - MPP] delete recipes', props()),
    deleteRecipesSuccess: createAction('[[NgRx - MPP] delete recipes success', props()),
    deleteRecipesFailure: createAction('[NgRx - MPP] delete recipes fail', props()),
    archiveRecipes: createAction('[NgRx - MPP] archive recipes', props()),
    archiveRecipesSuccess: createAction('[[NgRx - MPP] archive recipes success', props()),
    archiveRecipesFailure: createAction('[NgRx - MPP] archive recipes fail', props()),
    createRecipe: createAction('[NgRx - MPP] create recipes', props()),
    createRecipeSuccess: createAction('[NgRx - MPP] create recipes success', props()),
    createRecipeFailure: createAction('[NgRx - MPP] create recipes fail', props()),
    updateRecipesSort: createAction('[NgRx - MPP] Update sort direction of selected header and reset others to their default values in RecipesSort', props()),
    resetRecipesSort: createAction('[NgRx - MPP] Resets RecipesSort to its default value'),
    updateGroupFilter: createAction('[NgRx - MPP] Updates Group', props()),
    updateSearch: createAction('[NgRx - MPP] Updates search', props()),
    showHideArchive: createAction('[NgRx - MPP] Sets archive flag', props()),
    copyRecipe: createAction('[NgRx - MPP] copy recipes', props()),
    copyRecipeSuccess: createAction('[NgRx - MPP] copy recipes success', props()),
    copyRecipeFailure: createAction('[NgRx - MPP] copy recipes fail', props()),
    showHidePortion: createAction('[NgRx - MPP] show hide portion', props()),
    selectTab: createAction('[NgRx - MPP] select tab', props()),
    updateYieldValue: createAction('[NgRx - MPP] update yield value', props()),
    updateYieldUOM: createAction('[NgRx - MPP] update yield uom', props()),
    updateServingValue: createAction('[NgRx - MPP] update serving value', props()),
    updateServingUOM: createAction('[NgRx - MPP] update serving uom', props()),
    updateServingPerRecipeValue: createAction('[NgRx - MPP] update serving per recipe', props()),
    updateIngredientUOM: createAction('[NgRx - MPP] update ingredient uom', props()),
    updateIngredientQuantity: createAction('[NgRx - MPP] update ingredient quantity', props()),
    updateIngredientNote: createAction('[NgRx - MPP] update ingredient note', props()),
    updateIngredientCost: createAction('[NgRx - MPP] update ingredient cost', props()),
    updateRecipeSuccess: createAction('[NgRx - MPP] update recipes success', props()),
    updateRecipeFailure: createAction('[NgRx - MPP] update recipes fail', props()),
    getMyChanges: createAction('[NgRx - MPP] send timestamp to check changes', props()),
    getMyChangesSuccess: createAction('[NgRx - MPP] update recipes based on timestamps', props()),
    getMyChangesFailure: createAction('[NgRx - MPP] failed to check timestamps', props()),
    updateGroupName: createAction('[NgRx - MPP] update group names', props()),
    updateRecipeName: createAction('[NgRx - MPP] update recipe name', props()),
    updateDescription: createAction('[NgRx - MPP] update recipe description', props()),
    uploadRecipeProfileImageToS3: createAction('[NgRx - MPP] upload reciipe profile image', props()),
    uploadRecipeProfileImageToS3Success: createAction('[NgRx - MPP] upload reciipe profile image success', props()),
    uploadRecipeProfileImageToS3Failure: createAction('[NgRx - MPP] upload reciipe profile image fail', props()),
    setupRecipeDependencyGraph: createAction('[NgRx - MPP] setup recipe dependency graph'),
    updateRecipeDependencyGraph: createAction('[NgRx - MPP] Update dependency graph', props()),
    updateIngredientSearchKey: createAction('[NgRx - MPP] update ingredient search key', props()),
    getRecipeProfileImagesFromS3: createAction('[NgRx - MPP] get reciipe profile images', props()),
    getRecipeProfileImagesFromS3Success: createAction('[NgRx - MPP] get reciipe profile image/s success', props()),
    getRecipeProfileImagesFromS3Failure: createAction('[NgRx - MPP] get reciipe profile image/s fail', props()),
    addIngredientToRecipeRecipe: createAction('[NgRx - MPP] add ingredient to recipe recipe', props()),
    addIngredientToRecipeRecipeSuccess: createAction('[NgRx - MPP] add ingredient to recipe recipe success', props()),
    addIngredientToRecipeRecipeFailure: createAction('[NgRx - MPP] add ingredient to recipe recipe fail', props()),
    addIngredientToRecipeProduct: createAction('[NgRx - MPP] add ingredient to recipe product', props()),
    addIngredientToRecipeProductMultiple: createAction('[NgRx - MPP] add ingredients to recipe product', props()),
    addIngredientToRecipeProductSuccess: createAction('[NgRx - MPP] add ingredient to recipe product success', props()),
    addIngredientToRecipeProductFailure: createAction('[NgRx - MPP] add ingredient to recipe product fail', props()),
    addIngredientToRecipeNonUsfProductMultiple: createAction('[NgRx - MPP] add ingredients to recipe non usf product', props()),
    addIngredientToRecipeNonUsfProductSuccess: createAction('[NgRx - MPP] add ingredient to recipe non usf product success', props()),
    addIngredientToRecipeNonUsfProductFailure: createAction('[NgRx - MPP] add ingredient to recipe non usf product fail', props()),
    setImageURIValues: createAction('[NgRx - MPP] set image values to state', props()),
    deleteIngredient: createAction('[NgRx - MPP] delete ingredient', props()),
    deleteIngredientSuccess: createAction('[NgRx - MPP] delete ingredient Success', props()),
    deleteIngredientFailure: createAction('[NgRx - MPP] delete ingredient Failure', props()),
    selectIngredient: createAction('[NgRx - MPP] select ingredient', props()),
    updateCostIngredient: createAction('[NgRx - MPP] UpdateCost api update ingredient cost', props()),
    updateCostIngredientSuccess: createAction('[NgRx - MPP] UpdateCost api update ingredient cost Success', props()),
    updateCostIngredientFailure: createAction('[NgRx - MPP] UpdateCost api update ingredient cost Failure', props()),
    updateCalculations: createAction('[NgRx - MPP] edits calculations for uom details pane', props()),
    updateRecipeLockInd: createAction('[NgRx - MPP] toggle recipe lock indicator', props()),
};

/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
class MPPService {
    store;
    panAppState;
    constructor(store, panAppState) {
        this.store = store;
        this.panAppState = panAppState;
    }
    initialize() {
        // Not applying a filter to check customer data being setup because the action only clears data
        this.panAppState.session$.subscribe((session) => {
            this.store.dispatch(RECIPE_ACTIONS.resetRecipes());
        });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MPPService, deps: [{ token: i1$1.Store }, { token: i2.PanAppState }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MPPService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MPPService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.Store }, { type: i2.PanAppState }]; } });

class MppEffects {
    actions$;
    httpService;
    constructor(actions$, httpService) {
        this.actions$ = actions$;
        this.httpService = httpService;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MppEffects, deps: [{ token: i3.Actions }, { token: ToolsHttpClientService }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MppEffects, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MppEffects, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i3.Actions }, { type: ToolsHttpClientService }]; } });

var RecipeSortOptions;
(function (RecipeSortOptions) {
    RecipeSortOptions["recipeName"] = "recipeName";
    RecipeSortOptions["group"] = "group";
    RecipeSortOptions["serving"] = "serving";
    RecipeSortOptions["servingSize"] = "servingSize";
    RecipeSortOptions["costRecipe"] = "costRecipe";
    RecipeSortOptions["costServing"] = "costServing";
    RecipeSortOptions["yield"] = "yield";
})(RecipeSortOptions || (RecipeSortOptions = {}));
var SortDirections;
(function (SortDirections) {
    SortDirections["asc"] = "asc";
    SortDirections["desc"] = "desc";
})(SortDirections || (SortDirections = {}));
const recipeHeaders = {
    [RecipeSortOptions.recipeName]: {
        sortDirection: SortDirections.asc,
        displayText: 'Recipe',
    },
    [RecipeSortOptions.group]: {
        sortDirection: SortDirections.desc,
        displayText: 'Group',
    },
    [RecipeSortOptions.yield]: {
        sortDirection: SortDirections.desc,
        displayText: 'Yield',
    },
    [RecipeSortOptions.serving]: {
        sortDirection: SortDirections.desc,
        displayText: 'Servings',
    },
    [RecipeSortOptions.servingSize]: {
        sortDirection: SortDirections.desc,
        displayText: 'Serving Size',
    },
    [RecipeSortOptions.costRecipe]: {
        sortDirection: SortDirections.desc,
        displayText: 'Cost Recipe',
    },
    [RecipeSortOptions.costServing]: {
        sortDirection: SortDirections.desc,
        displayText: 'Cost Serving',
    },
};
const initialRecipesSort = {
    recipes: {
        selectedHeader: RecipeSortOptions.recipeName,
        headers: recipeHeaders,
    },
};

var RecipeDetailTabs;
(function (RecipeDetailTabs) {
    RecipeDetailTabs["ingredients"] = "ing";
    RecipeDetailTabs["preperation"] = "prep";
    RecipeDetailTabs["unitOfMeasure"] = "uom";
})(RecipeDetailTabs || (RecipeDetailTabs = {}));
var INGREDIENT_OPTIONS;
(function (INGREDIENT_OPTIONS) {
    INGREDIENT_OPTIONS["RECIPE"] = "RECIPE";
    INGREDIENT_OPTIONS["PRODUCT"] = "PRODUCT";
    INGREDIENT_OPTIONS["NON_USFOODS_PRODUCT"] = "NON_USFOODS_PRODUCT";
})(INGREDIENT_OPTIONS || (INGREDIENT_OPTIONS = {}));

/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable @typescript-eslint/no-explicit-any */
const recipeAdapter = createEntityAdapter({
    selectId: (recipe) => recipe.recipeId,
});
const initialRecipeState = recipeAdapter.getInitialState({
    loaded: false,
    recipeSort: initialRecipesSort,
    filterArchive: true,
    searchKey: '',
    groupFilter: [],
    copiedRecipes: {},
    currentCopyId: null,
    details: {
        selectedTab: RecipeDetailTabs.ingredients,
        showPortion: false,
    },
    recipeDependencyGraph: {
        childrenOfRecipe: {},
        ancestorsOfRecipe: {},
        maxAncestorDepth: {},
        maxChildDepth: {},
    },
    ingredientSearchKey: '',
    recipeSRC: {},
    didLoadPhotos: false,
});
const _recipeReducer = createReducer(initialRecipeState, on(RECIPE_ACTIONS.resetRecipes, (state) => {
    return {
        ...state,
        ids: [],
        entities: {},
        loaded: false,
        loading: false,
        didLoadPhotos: false,
    };
}), on(RECIPE_ACTIONS.resetSelections, (state) => {
    const result = [];
    Object.values(state.entities).forEach((item) => {
        result.push({ ...item, isSelected: false });
    });
    return recipeAdapter.upsertMany(result, state);
}), on(RECIPE_ACTIONS.getRecipes, (state, action) => {
    return {
        ...state,
        loaded: false,
        loading: true,
        currentCustomerNumber: action.customerNumber,
    };
}), on(RECIPE_ACTIONS.getRecipesSuccess, (state, action) => {
    return recipeAdapter.upsertMany(action.recipes, {
        ...state,
        loading: false,
        loaded: true,
        watermark: new Date().toISOString(),
    });
}), on(RECIPE_ACTIONS.getRecipesFailure, (state, action) => {
    return {
        ...state,
        error: action.error,
        loaded: true,
        loading: false,
    };
}), on(RECIPE_ACTIONS.selectRecipe, (state, action) => {
    const recipe = { ...state.entities[action.recipeId] };
    if (!!recipe) {
        recipe.isSelected = !recipe.isSelected;
        return recipeAdapter.upsertOne(recipe, state);
    }
    else {
        return state;
    }
}), on(RECIPE_ACTIONS.selectMultiple, (state, action) => {
    const result = [];
    action.recipeIds.forEach((id) => {
        result.push({ ...state.entities[id], isSelected: true });
    });
    return recipeAdapter.upsertMany(result, state);
}), on(RECIPE_ACTIONS.deselectMultiple, (state, action) => {
    const result = [];
    action.recipeIds.forEach((id) => {
        result.push({ ...state.entities[id], isSelected: false });
    });
    return recipeAdapter.upsertMany(result, state);
}), on(RECIPE_ACTIONS.selectRecipeForPageView, (state, action) => {
    return { ...state, selectedID: action.recipeId };
}), on(RECIPE_ACTIONS.archiveRecipesSuccess, (state, action) => {
    const recipes = [];
    action.archiveRecipe.recipeIds.forEach((recipeId) => {
        const recipe = state.entities[recipeId];
        if (!!recipe) {
            recipe.archiveInd = action.archiveRecipe.isArchive;
            recipes.push(recipe);
        }
    });
    return recipeAdapter.upsertMany(recipes, state);
}), on(RECIPE_ACTIONS.deleteRecipesSuccess, (state, action) => {
    return recipeAdapter.removeMany(action.recipeIds, state);
}), on(RECIPE_ACTIONS.createRecipeSuccess, (state, action) => {
    const newRecipe = { ...action.recipe };
    return recipeAdapter.addOne(newRecipe, state);
}), on(RECIPE_ACTIONS.updateRecipesSort, (state, action) => {
    const updatedHeaders = updateInventorySortHeaders(state.recipeSort, 'recipes', action.selectedHeader, RecipeSortOptions.recipeName, recipeHeaders, action.sortDirection);
    return {
        ...state,
        recipeSort: {
            recipes: {
                selectedHeader: action.selectedHeader,
                headers: updatedHeaders,
            },
        },
    };
}), on(RECIPE_ACTIONS.resetRecipesSort, (state) => ({
    ...state,
    recipeSort: initialRecipesSort,
})), on(RECIPE_ACTIONS.updateGroupFilter, (state, action) => ({
    ...state,
    groupFilter: action.groups,
})), on(RECIPE_ACTIONS.updateSearch, (state, action) => ({
    ...state,
    searchKey: action.searchKey,
})), on(RECIPE_ACTIONS.showHideArchive, (state, action) => ({
    ...state,
    filterArchive: action.flag,
})), on(RECIPE_ACTIONS.copyRecipeSuccess, (state, action) => {
    const recipes = action.recipes.map((recipe) => ({
        ...recipe,
        isCopied: true,
    }));
    // Ensure that the entity state is updated with new recipes
    return recipeAdapter.upsertMany(recipes, {
        ...state,
        copiedRecipes: {
            ...state.copiedRecipes,
            [action.copyId]: action.recipes.map((recipe) => recipe.recipeId),
        },
        currentCopyId: action.copyId, // Store the generated copyId
    });
}), on(RECIPE_ACTIONS.copyRecipeFailure, (state, action) => {
    return {
        ...state,
        error: action.error,
    };
}), on(RECIPE_ACTIONS.showHidePortion, (state, action) => {
    return {
        ...state,
        details: { ...state.details, showPortion: action.show },
    };
}), on(RECIPE_ACTIONS.selectTab, (state, action) => {
    return {
        ...state,
        details: { ...state.details, selectedTab: action.tab },
    };
}), on(RECIPE_ACTIONS.updateServingPerRecipeValue, (state, action) => {
    const value = !action.value ? 1 : action.value;
    const recipe = {
        ...state.entities[action.recipeId],
        servingPerBatch: value,
    };
    return recipeAdapter.upsertOne(recipe, state);
}), on(RECIPE_ACTIONS.updateServingUOM, (state, action) => {
    const recipe = {
        ...state.entities[action.recipeId],
        servingSizeUom: action.value,
    };
    return recipeAdapter.upsertOne(recipe, state);
}), on(RECIPE_ACTIONS.updateServingValue, (state, action) => {
    const value = !action.value ? undefined : action.value;
    const recipe = {
        ...state.entities[action.recipeId],
        servingSizeQuantity: value,
    };
    return recipeAdapter.upsertOne(recipe, state);
}), on(RECIPE_ACTIONS.updateYieldUOM, (state, action) => {
    const value = !action.value ? undefined : action.value;
    const recipe = {
        ...state.entities[action.recipeId],
        yieldUomOverride: value,
    };
    return recipeAdapter.upsertOne(recipe, state);
}), on(RECIPE_ACTIONS.updateYieldValue, (state, action) => {
    const value = !action.value ? undefined : action.value;
    const recipe = {
        ...state.entities[action.recipeId],
        yieldOverride: value,
    };
    return recipeAdapter.upsertOne(recipe, state);
}), on(RECIPE_ACTIONS.updateRecipeLockInd, (state, action) => {
    const recipe = {
        ...state.entities[action.recipeId],
        lockInd: action.value,
    };
    return recipeAdapter.upsertOne(recipe, state);
}), on(RECIPE_ACTIONS.updateIngredientUOM, (state, action) => {
    const recipe = { ...state.entities[action.recipeId] };
    if (!recipe?.ingredientList) {
        return state;
    }
    const updatedIngredientList = recipe?.ingredientList?.map((ingredient) => {
        if (ingredient?.ingredientId !== null &&
            action?.ingredientId !== null &&
            ingredient.ingredientId === action.ingredientId) {
            return {
                ...ingredient,
                quantityUom: action.value,
            };
        }
        return ingredient;
    });
    const updatedRecipe = {
        ...recipe,
        ingredientList: updatedIngredientList,
    };
    return recipeAdapter.upsertOne(updatedRecipe, state);
}), on(RECIPE_ACTIONS.updateIngredientQuantity, (state, action) => {
    const recipe = { ...state.entities[action.recipeId] };
    if (!recipe?.ingredientList) {
        return state;
    }
    const updatedIngredientList = recipe?.ingredientList?.map((ingredient) => {
        if (ingredient?.ingredientId !== null &&
            action?.ingredientId !== null &&
            ingredient.ingredientId === action.ingredientId) {
            return {
                ...ingredient,
                quantity: action.value,
            };
        }
        return ingredient;
    });
    const updatedRecipe = {
        ...recipe,
        ingredientList: updatedIngredientList,
    };
    return recipeAdapter.upsertOne(updatedRecipe, state);
}), on(RECIPE_ACTIONS.updateIngredientCost, (state, action) => {
    const recipe = { ...state.entities[action.recipeId] };
    if (!recipe?.ingredientList) {
        return state;
    }
    const updatedIngredientList = recipe.ingredientList?.map((ingredient) => {
        if (ingredient?.ingredientId !== null &&
            action?.ingredientId !== null &&
            ingredient.ingredientId === action.ingredientId) {
            return {
                ...ingredient,
                cost: action.cost,
            };
        }
        return ingredient;
    });
    const updatedRecipe = {
        ...recipe,
        ingredientList: updatedIngredientList,
    };
    return recipeAdapter.upsertOne(updatedRecipe, state);
}), on(RECIPE_ACTIONS.updateIngredientNote, (state, action) => {
    const recipe = state.entities[action.recipeId];
    if (!recipe?.ingredientList) {
        return state;
    }
    const updatedIngredientList = recipe?.ingredientList?.map((ingredient) => {
        if (ingredient?.ingredientId !== null &&
            action?.ingredientId !== null &&
            ingredient.ingredientId === action.ingredientId) {
            return {
                ...ingredient,
                note: action.value,
            };
        }
        return ingredient;
    });
    const updatedRecipe = {
        ...recipe,
        ingredientList: updatedIngredientList,
    };
    return recipeAdapter.upsertOne(updatedRecipe, state);
}), on(RECIPE_ACTIONS.getMyChangesSuccess, (state, action) => {
    return recipeAdapter.upsertMany(action.recipes, {
        ...state,
        watermark: new Date().toISOString(),
    });
}), on(RECIPE_ACTIONS.updateRecipeSuccess, (state, action) => {
    return recipeAdapter.upsertOne(action.recipe, state);
}), on(RECIPE_ACTIONS.deleteIngredientSuccess, (state, action) => {
    return recipeAdapter.upsertMany(action.recipes, state);
}), on(RECIPE_ACTIONS.updateRecipeName, (state, action) => {
    const recipe = {
        ...state.entities[action.recipeId],
        recipeName: action.name,
    };
    return recipeAdapter.upsertOne(recipe, state);
}), on(RECIPE_ACTIONS.updateGroupName, (state, action) => {
    const recipe = {
        ...state.entities[action.recipeId],
        groupName: action.groupName,
    };
    return recipeAdapter.upsertOne(recipe, state);
}), on(RECIPE_ACTIONS.updateDescription, (state, action) => {
    const recipe = {
        ...state.entities[action.recipeId],
        description: action.description,
    };
    return recipeAdapter.upsertOne(recipe, state);
}), on(RECIPE_ACTIONS.deleteIngredient, (state, action) => {
    const recipe = {
        ...state.entities[action.recipeId],
    };
    if (!!recipe.ingredientList) {
        const ingredient = recipe.ingredientList[action.index];
        recipe.ingredientList = recipe.ingredientList.filter((ing) => {
            return !(ing.ingredientId === ingredient.ingredientId &&
                ing.itemNumber === ingredient.itemNumber);
        });
        if (ingredient.type === ItemType.RECIPE) {
            const recipe2 = {
                ...state.entities[ingredient.itemNumber],
            };
            if (!!recipe2.referencedRecipeList) {
                recipe2.referencedRecipeList = recipe2.referencedRecipeList.filter((id) => id !== action.recipeId);
            }
            return recipeAdapter.upsertMany([recipe, recipe2], state);
        }
    }
    return recipeAdapter.upsertOne(recipe, state);
}), on(RECIPE_ACTIONS.getRecipeProfileImagesFromS3Success, (state) => {
    return { ...state, didLoadPhotos: true };
}), on(RECIPE_ACTIONS.setImageURIValues, (state, action) => {
    const recipeRecords = { ...state.recipeSRC };
    action.recipeImages.forEach((data) => {
        recipeRecords[data.recipeID] = data;
    });
    return {
        ...state,
        recipeSRC: recipeRecords,
    };
}), on(RECIPE_ACTIONS.uploadRecipeProfileImageToS3Success, (state, action) => {
    const recipe = {
        ...state.entities[action.uploadImageResponse.recipeId],
        imageFilePathInS3: action.uploadImageResponse.s3Response.value,
    };
    return recipeAdapter.upsertOne(recipe, state);
}), on(RECIPE_ACTIONS.setupRecipeDependencyGraph, (state) => {
    return {
        ...state,
        recipeDependencyGraph: buildRecipeDependencyGraph(state),
    };
}), on(RECIPE_ACTIONS.updateIngredientSearchKey, (state, action) => {
    return {
        ...state,
        ingredientSearchKey: action.searchKey,
    };
}), on(RECIPE_ACTIONS.updateRecipeDependencyGraph, (state, action) => {
    return action.isAdd
        ? addToDependencyGraph(state, state.recipeDependencyGraph, action.recipes)
        : deleteFromDependencyGraph(state, state.recipeDependencyGraph, action.recipes);
}), on(RECIPE_ACTIONS.addIngredientToRecipeRecipe, (state, action) => {
    const recipeParent = {
        ...state.entities[action.recipeId],
    };
    const recipeChild = {
        ...state.entities[action.ingredient.itemNumber],
    };
    const nextIngredientId = generateNextIngredientId(recipeParent.ingredientList ?? []);
    const ingredientWithId = {
        ...action.ingredient,
        ingredientId: nextIngredientId,
    };
    if (!!recipeParent.ingredientList) {
        recipeParent.ingredientList = recipeParent.ingredientList.concat(ingredientWithId);
    }
    else {
        recipeParent.ingredientList = [ingredientWithId];
    }
    recipeChild.referencedRecipeList = (recipeChild.referencedRecipeList ?? []).concat(action.recipeId);
    return recipeAdapter.upsertMany([recipeParent, recipeChild], state);
}), on(RECIPE_ACTIONS.addIngredientToRecipeProduct, (state, action) => {
    const recipe = {
        ...state.entities[action.recipeId],
    };
    const nextIngredientId = generateNextIngredientId(recipe.ingredientList ?? []);
    const ingredientWithId = {
        ...action.ingredient,
        ingredientId: nextIngredientId,
    };
    if (!!recipe.ingredientList) {
        recipe.ingredientList = recipe.ingredientList.concat(ingredientWithId);
    }
    else {
        recipe.ingredientList = [ingredientWithId];
    }
    return recipeAdapter.upsertOne(recipe, state);
}), on(RECIPE_ACTIONS.addIngredientToRecipeProductMultiple, (state, action) => {
    const recipe = {
        ...state.entities[action.recipeId],
    };
    const ingredientsToAdd = [
        ...(recipe.ingredientList ?? []),
    ];
    (action.ingredients ?? []).forEach((item) => {
        const nextIngredientId = generateNextIngredientId(ingredientsToAdd);
        ingredientsToAdd.push({
            ...item,
            ingredientId: nextIngredientId,
        });
    });
    recipe.ingredientList = ingredientsToAdd;
    return recipeAdapter.upsertOne(recipe, state);
}), on(RECIPE_ACTIONS.addIngredientToRecipeNonUsfProductMultiple, (state, action) => {
    const recipe = {
        ...state.entities[action.recipeId],
    };
    const ingredientsToAdd = [
        ...(recipe.ingredientList ?? []),
    ];
    (action.ingredients ?? []).forEach((item) => {
        const nextIngredientId = generateNextIngredientId(ingredientsToAdd);
        ingredientsToAdd.push({
            ...item,
            ingredientId: nextIngredientId,
        });
    });
    recipe.ingredientList = ingredientsToAdd;
    return recipeAdapter.upsertOne(recipe, state);
}), on(RECIPE_ACTIONS.addIngredientToRecipeRecipeSuccess, (state, action) => {
    return recipeAdapter.upsertMany(action.recipes, state);
}), on(RECIPE_ACTIONS.addIngredientToRecipeProductSuccess, (state, action) => {
    return recipeAdapter.upsertOne(action.recipe, state);
}), on(RECIPE_ACTIONS.addIngredientToRecipeNonUsfProductSuccess, (state, action) => {
    return recipeAdapter.upsertOne(action.recipe, state);
}), on(RECIPE_ACTIONS.addIngredientToRecipeProductFailure, (state) => {
    return {
        ...state,
        isValidAdd: true,
    };
}), on(RECIPE_ACTIONS.selectIngredient, (state, action) => {
    return {
        ...state,
        lastSelectedIngredient: action.id,
    };
}), on(RECIPE_ACTIONS.updateCostIngredientSuccess, (state, action) => {
    return recipeAdapter.upsertMany(action.mppObjectDto.recipes, state);
}), on(RECIPE_ACTIONS.updateCalculations, (state, action) => {
    return { ...state, calculations: action.calculations };
}));
const generateNextIngredientId = (ingredientList = []) => {
    const maxId = Math.max(0, ...ingredientList.map((i) => i.ingredientId ?? 0));
    return maxId + 1;
};
const deleteFromDependencyGraph = (state, graph, ids) => {
    const newGraph = {
        childrenOfRecipe: {},
        ancestorsOfRecipe: {},
        maxAncestorDepth: {},
        maxChildDepth: {},
    };
    for (const key in graph.childrenOfRecipe) {
        if (!ids.includes(key)) {
            newGraph.childrenOfRecipe[key] = graph.childrenOfRecipe[key];
        }
    }
    for (const key in graph.ancestorsOfRecipe) {
        if (!ids.includes(key)) {
            newGraph.ancestorsOfRecipe[key] = graph.ancestorsOfRecipe[key];
        }
    }
    for (const key in graph.maxAncestorDepth) {
        if (!ids.includes(key)) {
            newGraph.maxAncestorDepth[key] = graph.maxAncestorDepth[key];
        }
    }
    for (const key in graph.maxChildDepth) {
        if (!ids.includes(key)) {
            newGraph.maxChildDepth[key] = graph.maxChildDepth[key];
        }
    }
    return {
        ...state,
        recipeDependencyGraph: newGraph,
    };
};
const addToDependencyGraph = (state, graph, adjustments) => {
    adjustments.forEach((recipeID) => {
        graph.childrenOfRecipe[recipeID] = new Set();
        graph.ancestorsOfRecipe[recipeID] = new Set();
        graph.maxChildDepth[recipeID] = 0;
        graph.maxAncestorDepth[recipeID] = 0;
    });
    return {
        ...state,
        recipeDependencyGraph: graph,
    };
};
const getChildrenData = (recipe) => {
    return (recipe?.ingredientList || [])
        .filter((ingredient) => ingredient.type === ItemType.RECIPE)
        .map((ingredient) => ingredient.itemNumber);
};
const getAncestorsData = (recipe) => {
    return recipe?.referencedRecipeList || [];
};
const buildRecipeDependencyGraph = (state) => {
    const graph = {
        childrenOfRecipe: {},
        ancestorsOfRecipe: {},
        maxAncestorDepth: {},
        maxChildDepth: {},
    };
    const childData = getRelationalData(state, getChildrenData);
    const ancestorData = getRelationalData(state, getAncestorsData);
    graph.childrenOfRecipe = childData.iterativeRecipes;
    graph.ancestorsOfRecipe = ancestorData.iterativeRecipes;
    graph.maxChildDepth = childData.depthCheck;
    graph.maxAncestorDepth = ancestorData.depthCheck;
    return graph;
};
const getRelationalData = (state, dataExtractionFunction) => {
    const depthCheck = {};
    const iterativeRecipes = {};
    const alreadyEvaluatedRecipes = new Set();
    Object.values(state.entities).forEach((recipe) => {
        if (!recipe)
            return;
        if (alreadyEvaluatedRecipes.has(recipe.recipeId)) {
            return;
        }
        const recipeId = recipe.recipeId;
        depthCheck[recipeId] = 0;
        iterativeRecipes[recipeId] = new Set(dataExtractionFunction(recipe));
        const layers = [];
        let currentLayer = [...iterativeRecipes[recipeId]];
        layers.push(currentLayer);
        const processedRecipes = new Set();
        while (currentLayer.length > 0) {
            const nextLayer = [];
            for (let i = 0; i < currentLayer.length; i++) {
                const childId = currentLayer[i];
                if (processedRecipes.has(childId))
                    continue;
                processedRecipes.add(childId);
                const childRecipe = state.entities[childId];
                const childRecipeRefs = dataExtractionFunction(childRecipe);
                if (childRecipeRefs.length > 0) {
                    childRecipeRefs.forEach((grandchildId) => {
                        if (!processedRecipes.has(grandchildId)) {
                            nextLayer.push(grandchildId);
                            iterativeRecipes[recipeId].add(grandchildId);
                        }
                    });
                }
            }
            if (nextLayer.length > 0) {
                layers.push(nextLayer);
                currentLayer = nextLayer;
            }
            else {
                break;
            }
        }
        if (!depthCheck[recipeId]) {
            depthCheck[recipeId] = 0;
        }
        if (layers.length >= 1) {
            for (let i = 0; i < layers.length; i++) {
                const layerDepth = i + 1;
                layers[i].forEach((layerRecipeId) => {
                    alreadyEvaluatedRecipes.add(layerRecipeId);
                    if ((depthCheck[layerRecipeId] || 0) < layerDepth) {
                        depthCheck[layerRecipeId] = layerDepth;
                    }
                });
            }
        }
    });
    return {
        depthCheck,
        iterativeRecipes,
    };
};
const resetDefaultHeaderSortDirection = (defaultHeader, sortDirection) => {
    switch (defaultHeader) {
        case RecipeSortOptions.recipeName:
            sortDirection = SortDirections.desc;
            break;
        case RecipeSortOptions.group:
        case RecipeSortOptions.yield:
        case RecipeSortOptions.serving:
        case RecipeSortOptions.servingSize:
        case RecipeSortOptions.costRecipe:
        case RecipeSortOptions.costServing:
        default:
            sortDirection = SortDirections.asc;
            break;
    }
    return sortDirection;
};
const updateInventorySortHeaders = (recipeySort, recipeSection, selectedHeader, defaultHeader, initialHeaders, sortDirection) => selectedHeader === defaultHeader
    ? {
        ...initialHeaders,
        [selectedHeader]: {
            ...recipeySort[recipeSection].headers[selectedHeader],
            sortDirection,
        },
    }
    : {
        ...initialHeaders,
        [defaultHeader]: {
            ...recipeySort[recipeSection].headers[defaultHeader],
            sortDirection: resetDefaultHeaderSortDirection(defaultHeader, sortDirection),
        },
        [selectedHeader]: {
            ...recipeySort[recipeSection].headers[selectedHeader],
            sortDirection,
        },
    };
function recipeReducer(state, action) {
    return _recipeReducer(state, action);
}

var mppEndpoints;
(function (mppEndpoints) {
    mppEndpoints["getImagesFromS3"] = "recipe/profile-images";
    mppEndpoints["uploadToS3"] = "recipe-detail/upload";
    mppEndpoints["copy"] = "recipe/copy";
    mppEndpoints["archive"] = "recipe/archive";
    mppEndpoints["delete"] = "recipe/delete";
    mppEndpoints["recipe"] = "recipe";
    mppEndpoints["myChanges"] = "recipe/myChanges";
    mppEndpoints["bulkUpdate"] = "recipe/update/bulk";
    mppEndpoints["addMppProduct"] = "product";
    mppEndpoints["updateCost"] = "cost-update/update-cost";
})(mppEndpoints || (mppEndpoints = {}));

class UuidService {
    // Wrapper method for v4
    v4() {
        return v4();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UuidService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UuidService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UuidService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

// Is how we calculate dpeth, we don't want any recipes with more than this
// number of ancestor/parent(s)
// We start count by 0 since 0 means a Recipe not being used by any other Recipe.
const MAX_CHAIN_LENGTH = 4;

const selectRecipeState = createFeatureSelector(RECIPE_KEY);
const getAllRecipes = () => createSelector(selectRecipeState, (state) => Object.values(state.entities));
const getRecipeByIdFromState = () => createSelector(selectRecipeState, (state) => {
    if (state.selectedID) {
        return state.entities[state.selectedID];
    }
    else {
        return undefined;
    }
});
const getIsRecipeLoaded = () => createSelector(selectRecipeState, (state) => state.loaded ?? false);
const getAllRecipeFilters = () => createSelector(selectRecipeState, (state) => {
    return {
        groups: state.groupFilter,
        search: state.searchKey,
        filterArchive: state.filterArchive,
    };
});
const getRecipeSortableHeaders = () => createSelector(selectRecipeState, (state) => state.recipeSort);
const getCopiedRecipes = () => createSelector(selectRecipeState, (state) => {
    const currentUserCopyId = state.currentCopyId;
    const copiedRecipes = state.copiedRecipes || {};
    if (!currentUserCopyId || !copiedRecipes[currentUserCopyId]) {
        return [];
    }
    const copiedRecipeIds = copiedRecipes[currentUserCopyId];
    return copiedRecipeIds
        .map((recipeId) => state.entities[recipeId])
        .filter((recipe) => recipe);
});
const getRecipeDetails = () => createSelector(selectRecipeState, (state) => state.details);
const getWatermark = () => createSelector(selectRecipeState, (state) => state.watermark);
const buildRecipeRecommendationBlacklist = (recipe, recipeState) => {
    const blacklist = new Set();
    // Can't reccomend itself
    blacklist.add(recipe.recipeId);
    // Add all Ancestors to blacklist, if A is already contained as a child directly or indirectly then the recipe that parents A should not be shown
    recipeState.recipeDependencyGraph.ancestorsOfRecipe[recipe.recipeId]?.forEach((parents) => blacklist.add(parents));
    (recipe?.ingredientList || [])
        .filter((ingredient) => ingredient.type === ItemType.RECIPE)
        .forEach((item) => {
        blacklist.add(item.itemNumber);
    });
    const currentRecipeDepth = recipeState.recipeDependencyGraph.maxChildDepth[recipe.recipeId];
    // a0 - c3, a1 - c2, a2 - c1, a3 - c0
    // a3 and c3 are max length IE a3: c3: a(a3) - b -c - d(c3)
    // a1 - c2: a - b (a1) + a - b - c (c2)
    // a2 - c1: a - b - c (a2) + a - b (c1)
    // a3 - c0: a - b - c - d (a3) + a (co)
    // we start at 0, so the 1's accont for the recipe itself
    // so A(3) is a chain of 4
    // a(to add/search) + 1 + c(detail/target/current) + 1 <= max_chain_length
    // if we have a recipe of ancesotorDepth 4 than nobody should see it
    // if our target recipe has a childDepth of 4 than nothing can be added to it.
    // a: c0 a0
    // a: a3 c0  -> b: a2 c1 -> c: a1 c2-> d: a0 c3
    // need to account for true chain vs reported depth so:
    //  a0 === 1, a1 === 2
    // c0 === 1, c2 === 3
    // MAX_ANCESTOR_COUNT should end up with allowing only up to 4 recipes in a chain
    Object.entries(recipeState.recipeDependencyGraph.maxAncestorDepth).forEach((recipeDepth) => {
        // the +1 is to account for chain length
        if (recipeDepth[1] + 1 + (currentRecipeDepth + 1) > MAX_CHAIN_LENGTH) {
            blacklist.add(recipeDepth[0]);
        }
    });
    return blacklist;
};
const getIngreidentSearchKey = () => createSelector(selectRecipeState, (state) => state.ingredientSearchKey);
const getFilteredRecipeDataForSearchBasedOnBlacklist = () => createSelector(selectRecipeState, (state) => {
    if (!state.selectedID || !state.entities[state.selectedID]) {
        return { recipeData: [], blackList: new Set() };
    }
    const recipe = state.entities[state.selectedID];
    let recipeData = [];
    let blackList;
    if (recipe) {
        blackList = buildRecipeRecommendationBlacklist(recipe, state);
        recipeData = Object.values(state.entities)
            .filter((r) => r && !blackList.has(r.recipeId))
            .filter((r) => !r?.archiveInd)
            .map((r) => ({
            id: r?.recipeId ?? '',
            name: r?.recipeName ?? '',
            types: INGREDIENT_OPTIONS.RECIPE,
            price: r?.cost ?? 0,
            priceUOM: r?.unitOfMeasure ?? '',
        }));
        return { recipeData, blackList };
    }
    return { recipeData, blackList: new Set() };
});
const selectRecipeImageSrc = () => createSelector(selectRecipeState, (state) => state.recipeSRC ?? {});
const selectRecipeImagesLoaded = () => createSelector(selectRecipeState, (state) => state.didLoadPhotos);
const selectLastRecipeCustomer = () => createSelector(selectRecipeState, (state) => state.currentCustomerNumber);
const selectLastSelectedIngredient = () => createSelector(selectRecipeState, (state) => state.lastSelectedIngredient);
const selectBaseCalculations = () => createSelector(selectRecipeState, (state) => state.calculations);
const { selectAll: selectAll$2, selectIds, selectEntities, selectTotal, } = recipeAdapter.getSelectors(selectRecipeState);

/* eslint-disable @typescript-eslint/no-explicit-any */
const MPP_PRODUCT_ACTIONS = {
    addMppProduct: createAction('[NgRx - MPP] add mpp product', props()),
    addMppProductSuccess: createAction('[NgRx - MPP] add mpp product success', props()),
    addMppProductFailure: createAction('[NgRx - MPP] add mpp product fail', props()),
    addMppProducts: createAction('[NgRx - MPP] add several mpp products', props()),
    addMppProductsSuccess: createAction('[NgRx - MPP] add several mpp products success', props()),
    addMppProductsFailure: createAction('[NgRx - MPP] add several mpp products fail', props()),
    getMppProducts: createAction('[NgRx - MPP] get MppProducts'),
    getMppProductsSuccess: createAction('[[NgRx - MPP] get MppProducts success', props()),
    getMppProductsFailure: createAction('[NgRx - MPP] get MppProducts fail', props()),
    updateMppProduct: createAction('[NgRx - MPP] update MppProducts', props()),
    updateMppProductSuccess: createAction('[NgRx - MPP] update MppProducts success', props()),
    updateMppProductFailure: createAction('[NgRx - MPP] update MppProducts failure', props()),
    deleteMppProduct: createAction('[NgRx - MPP] delete MppProducts', props()),
    deleteMppProductSuccess: createAction('[NgRx - MPP] delete MppProducts Success', props()),
    deleteMppProductFailure: createAction('[NgRx - MPP] delete MppProducts Failure', props()),
};

/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-shadow */
const mppProductAdapter = createEntityAdapter({
    selectId: (mpp) => mpp.productNumber,
});
const initialMPPState = mppProductAdapter.getInitialState({
    loaded: false,
});
// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
const _MppProductReducer = createReducer(initialMPPState, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
on(MPP_PRODUCT_ACTIONS.addMppProductSuccess, (state, action) => {
    return mppProductAdapter.upsertOne(action.mppProduct, state);
}), on(MPP_PRODUCT_ACTIONS.addMppProductsSuccess, (state, action) => {
    return mppProductAdapter.upsertMany(action.mppProducts, state);
}), on(MPP_PRODUCT_ACTIONS.updateMppProductSuccess, (state, action) => {
    return mppProductAdapter.upsertOne(action.mppProduct, state);
}), on(MPP_PRODUCT_ACTIONS.getMppProducts, (state, action) => {
    return {
        ...initialMPPState,
        loaded: false,
        loading: true,
        error: undefined,
    };
}), on(MPP_PRODUCT_ACTIONS.getMppProductsSuccess, (state, action) => {
    return mppProductAdapter.upsertMany(action.mppProducts, {
        ...state,
        loaded: true,
        loading: false,
    });
}), on(MPP_PRODUCT_ACTIONS.getMppProductsFailure, (state, action) => {
    return {
        ...state,
        loading: false,
        loaded: true,
        error: action.error,
    };
}));
function mppProductReducer(state, action) {
    return _MppProductReducer(state, action);
}

const selectMPPProductState = createFeatureSelector(MPP_PRODUCT_KEY);
const getAllMPPProducts = () => createSelector(selectMPPProductState, (state) => Object.values(state.entities));
const { selectAll: selectAll$1 } = mppProductAdapter.getSelectors(selectMPPProductState);

class IngredientCostService {
    constructor() { }
    calculateIngredientCost(ingredient, recipeEntities, mppProductEntities) {
        const quantity = ingredient.quantity ?? 0;
        if (quantity === 0)
            return 0;
        const uomKey = ingredient.quantityUom;
        if (ingredient.type === ItemType.RECIPE) {
            const subRecipe = recipeEntities[ingredient.itemNumber];
            if (subRecipe?.cost != null &&
                uomKey in (subRecipe.unitOfMeasure ?? {})) {
                const uomConversion = subRecipe.unitOfMeasure[uomKey];
                const yieldVal = subRecipe.recipeYield;
                const validYield = yieldVal != null && yieldVal > 0 && yieldVal <= 1 ? yieldVal : 1;
                return (subRecipe.cost / (validYield * uomConversion)) * quantity;
            }
            return 0;
        }
        if (ingredient.type === ItemType.USFPRODUCT) {
            const product = mppProductEntities[ingredient.itemNumber];
            if (product?.casePrice != null &&
                uomKey in (product.unitOfMeasure ?? {})) {
                const uomConversion = product.unitOfMeasure[uomKey];
                const yieldVal = product.productYield;
                const validYield = yieldVal != null && yieldVal > 0 && yieldVal <= 1 ? yieldVal : 1;
                return (product.casePrice / (validYield * uomConversion)) * quantity;
            }
            return 0;
        }
        return 0; // NONUSFPRODUCT or unknown
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IngredientCostService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IngredientCostService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IngredientCostService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

/* eslint-disable @typescript-eslint/no-unused-vars */
class RecipeEffects {
    actions$ = inject(Actions);
    store = inject(Store);
    /* prettier-ignore */
    httpService = inject(ToolsHttpClientService);
    uuidService = inject(UuidService);
    ingredientCostService = inject(IngredientCostService);
    getRecipe$ = createEffect(() => this.actions$.pipe(ofType(RECIPE_ACTIONS.getRecipes), switchMap(() => {
        return this.httpService.get(mppEndpoints.recipe).pipe(switchMap((response) => [
            RECIPE_ACTIONS.getRecipesSuccess({
                recipes: response,
            }),
            RECIPE_ACTIONS.setupRecipeDependencyGraph(),
        ]), catchError$1((error) => of(RECIPE_ACTIONS.getRecipesFailure({ error }))));
    })));
    deleteRecipe$ = createEffect(() => this.actions$.pipe(ofType(RECIPE_ACTIONS.deleteRecipes), withLatestFrom(this.store.select(selectRecipeState)), switchMap(([action, state]) => {
        const body = { recipeIds: action.recipeIds };
        return this.httpService.put(mppEndpoints.delete, body).pipe(switchMap((_response) => {
            let needToRebuild = false;
            if (state && state.recipeDependencyGraph) {
                action.recipeIds.forEach((val) => {
                    if (state.recipeDependencyGraph.maxChildDepth[val] > 0 ||
                        state.recipeDependencyGraph.maxAncestorDepth[val] > 0) {
                        needToRebuild = true;
                    }
                });
            }
            if (needToRebuild) {
                return [
                    RECIPE_ACTIONS.deleteRecipesSuccess({
                        recipeIds: action.recipeIds,
                    }),
                    RECIPE_ACTIONS.setupRecipeDependencyGraph(),
                ];
            }
            else {
                return [
                    RECIPE_ACTIONS.deleteRecipesSuccess({
                        recipeIds: action.recipeIds,
                    }),
                    RECIPE_ACTIONS.updateRecipeDependencyGraph({
                        recipes: action.recipeIds,
                        isAdd: false,
                    }),
                ];
            }
        }), catchError$1((error) => of(RECIPE_ACTIONS.deleteRecipesFailure({ error }))));
    })));
    archiveRecipe$ = createEffect(() => this.actions$.pipe(ofType(RECIPE_ACTIONS.archiveRecipes), switchMap((action) => {
        const body = action.archiveRecipe;
        return this.httpService.put(mppEndpoints.archive, body).pipe(map(() => RECIPE_ACTIONS.archiveRecipesSuccess(action)), catchError$1((error) => of(RECIPE_ACTIONS.archiveRecipesFailure({ error }))));
    })));
    creteRecipe$ = createEffect(() => this.actions$.pipe(ofType(RECIPE_ACTIONS.createRecipe), switchMap((action) => {
        const body = action.recipe;
        return this.httpService.post(mppEndpoints.recipe, body).pipe(switchMap((response) => [
            RECIPE_ACTIONS.createRecipeSuccess({ recipe: response }),
            RECIPE_ACTIONS.updateRecipeDependencyGraph({
                recipes: [response.recipeId],
                isAdd: true,
            }),
        ]), catchError$1((error) => of(RECIPE_ACTIONS.createRecipeFailure({ error }))));
    })));
    copyRecipe$ = createEffect(() => this.actions$.pipe(ofType(RECIPE_ACTIONS.copyRecipe), switchMap((action) => {
        const body = action.copyRecipes;
        return this.httpService.post(mppEndpoints.copy, body).pipe(map((response) => RECIPE_ACTIONS.copyRecipeSuccess({
            copyId: `${body.userId}-${this.uuidService.v4()}`,
            recipes: response,
        })), catchError$1((error) => of(RECIPE_ACTIONS.copyRecipeFailure({ error }))));
    })));
    updateRecipe$ = createEffect(() => this.actions$.pipe(ofType(RECIPE_ACTIONS.updateServingUOM, RECIPE_ACTIONS.updateServingValue, RECIPE_ACTIONS.updateServingPerRecipeValue, RECIPE_ACTIONS.updateYieldUOM, RECIPE_ACTIONS.updateYieldValue, RECIPE_ACTIONS.updateGroupName, RECIPE_ACTIONS.updateRecipeName, RECIPE_ACTIONS.updateDescription, RECIPE_ACTIONS.updateIngredientNote, RECIPE_ACTIONS.updateRecipeLockInd), withLatestFrom(this.store.select(selectRecipeState)), filter(([action, state]) => state &&
        state.entities &&
        state.entities[action.recipeId] !== undefined), switchMap(([action, state]) => {
        const body = state.entities[action.recipeId];
        let servingCount = body.servingPerBatch;
        if (action.type === RECIPE_ACTIONS.updateServingPerRecipeValue.type &&
            action.value) {
            servingCount = action.value;
            body.servingPerBatch = action.value;
            const totalCost = body.cost ?? 0;
            body.costPerServing =
                servingCount && servingCount > 0
                    ? Number((totalCost / servingCount).toFixed(2))
                    : 0;
        }
        const timestamp = state.watermark ?? new Date().toISOString();
        return this.httpService.post(mppEndpoints.recipe, body).pipe(switchMap((response) => {
            return of(RECIPE_ACTIONS.updateRecipeSuccess({ recipe: response }), RECIPE_ACTIONS.getMyChanges({ timestamp }));
        }), catchError$1((error) => of(RECIPE_ACTIONS.updateRecipeFailure({ error }), RECIPE_ACTIONS.getMyChanges({ timestamp }))));
    })));
    updateRecipeIngredient$ = createEffect(() => this.actions$.pipe(ofType(RECIPE_ACTIONS.updateIngredientUOM, RECIPE_ACTIONS.updateIngredientQuantity), withLatestFrom(this.store.select(selectRecipeState), this.store.select(selectMPPProductState)), filter(([action, state, productState]) => {
        const recipe = state.entities[action.recipeId];
        const ingredient = recipe?.ingredientList?.find((i) => i.ingredientId === action.ingredientId);
        return !!recipe && !!ingredient && !!productState?.entities;
    }), map(([action, state, productState]) => {
        const recipe = state.entities[action.recipeId];
        const ingredient = recipe.ingredientList.find((i) => i.ingredientId === action.ingredientId);
        const cost = this.ingredientCostService.calculateIngredientCost(ingredient, state.entities, productState.entities);
        return RECIPE_ACTIONS.updateIngredientCost({
            recipeId: action.recipeId,
            ingredientId: action.ingredientId,
            cost,
        });
    })));
    persistRecipeIngredientCost$ = createEffect(() => this.actions$.pipe(ofType(RECIPE_ACTIONS.updateIngredientCost), withLatestFrom(this.store.select(selectRecipeState)), filter(([action, state]) => !!state.entities[action.recipeId]), switchMap(([action, state]) => {
        const recipe = state.entities[action.recipeId];
        // Update the ingredient's cost
        const updatedIngredientList = (recipe.ingredientList ?? []).map((i) => i.ingredientId === action.ingredientId
            ? { ...i, cost: action.cost }
            : i);
        // Recalculate total cost and cost per serving
        const totalCost = updatedIngredientList.reduce((sum, ing) => sum +
            (typeof ing.cost === 'number' ? ing.cost : Number(ing.cost) || 0), 0);
        const costPerServing = recipe.servingPerBatch && recipe.servingPerBatch > 0
            ? Number((totalCost / recipe.servingPerBatch).toFixed(2))
            : 0;
        const updatedRecipe = {
            ...recipe,
            ingredientList: updatedIngredientList,
            cost: totalCost,
            costPerServing,
            updateDtm: new Date().toISOString(),
        };
        const timestamp = state.watermark ?? new Date().toISOString();
        return this.httpService
            .post(mppEndpoints.recipe, updatedRecipe)
            .pipe(switchMap((response) => {
            const actions = [
                RECIPE_ACTIONS.updateRecipeSuccess({ recipe: response }),
            ];
            // Only call updateCostIngredient if cost has changed and there are referenced recipes
            const originalCost = Number(recipe.cost ?? 0);
            const newCost = Number(response.cost ?? 0);
            const costChanged = originalCost !== newCost;
            if (costChanged &&
                response.referencedRecipeList &&
                response.referencedRecipeList.length > 0) {
                actions.push(RECIPE_ACTIONS.updateCostIngredient({
                    costUpdateDto: {
                        costUpdateItem: [
                            {
                                id: response.recipeId,
                                cost: newCost,
                                productYield: 1,
                                unitOfMeasure: response.unitOfMeasure ?? {},
                                referencedRecipeList: response.referencedRecipeList ?? [],
                                referencedMenuItemList: response.referencedMenuItemList ?? [],
                                referencedEventPlanList: response.referencedEventPlanList ?? [],
                            },
                        ],
                    },
                }));
            }
            return actions;
        }), catchError$1((error) => of(RECIPE_ACTIONS.updateRecipeFailure({ error }), RECIPE_ACTIONS.getMyChanges({ timestamp }))));
    })));
    deleteRecipeIngredient$ = createEffect(() => this.actions$.pipe(ofType(RECIPE_ACTIONS.deleteIngredient), withLatestFrom(this.store.select(selectRecipeState)), filter(([action, state]) => state &&
        state.entities &&
        state.entities[action.recipeId] !== undefined), switchMap(([action, state]) => {
        const originalRecipe = { ...state.entities[action.recipeId] };
        const originalCost = Number(originalRecipe.cost ?? 0);
        originalRecipe.cost = (originalRecipe?.ingredientList ?? []).reduce((sum, ing) => sum + (ing.cost ?? 0), 0);
        const servingPerBatch = Number(originalRecipe.servingPerBatch ?? 0);
        originalRecipe.costPerServing =
            servingPerBatch > 0
                ? Number((originalRecipe.cost / servingPerBatch).toFixed(2))
                : 0;
        originalRecipe.updateDtm = new Date().toISOString();
        const recipeDto = [originalRecipe];
        if (action.itemType === ItemType.RECIPE && !!action.childRecipeID) {
            recipeDto.push({ ...state.entities[action.childRecipeID] });
        }
        const timestamp = state.watermark ?? new Date().toISOString();
        return this.httpService
            .post(mppEndpoints.bulkUpdate, { recipeDto })
            .pipe(mergeMap((response) => {
            const actions = [
                RECIPE_ACTIONS.deleteIngredientSuccess({ recipes: response }),
            ];
            if (action.itemType === ItemType.RECIPE) {
                actions.push(RECIPE_ACTIONS.setupRecipeDependencyGraph());
            }
            const newCost = Number(originalRecipe.cost ?? 0);
            const costChanged = originalCost !== newCost;
            if (costChanged &&
                originalRecipe.referencedRecipeList &&
                originalRecipe.referencedRecipeList.length > 0) {
                actions.push(RECIPE_ACTIONS.updateCostIngredient({
                    costUpdateDto: {
                        costUpdateItem: [
                            {
                                id: originalRecipe?.recipeId ?? '',
                                cost: Number(originalRecipe.cost ?? 0),
                                productYield: 1,
                                unitOfMeasure: originalRecipe.unitOfMeasure ?? {},
                                referencedRecipeList: originalRecipe.referencedRecipeList ?? [],
                                referencedMenuItemList: originalRecipe.referencedMenuItemList ?? [],
                                referencedEventPlanList: originalRecipe.referencedEventPlanList ?? [],
                            },
                        ],
                    },
                }));
            }
            return actions;
        }), catchError$1((error) => of(RECIPE_ACTIONS.deleteIngredientFailure({ error }), RECIPE_ACTIONS.getMyChanges({ timestamp }))));
    })));
    myChanges$ = createEffect(() => this.actions$.pipe(ofType(RECIPE_ACTIONS.getMyChanges), switchMap((action) => {
        return this.httpService
            .get(mppEndpoints.myChanges, action.timestamp)
            .pipe(switchMap((response) => [
            RECIPE_ACTIONS.getMyChangesSuccess({
                recipes: response,
            }),
            RECIPE_ACTIONS.setupRecipeDependencyGraph(),
        ]), catchError$1((error) => of(RECIPE_ACTIONS.getMyChangesFailure({ error }))));
    })));
    uploadToS3$ = createEffect(() => this.actions$.pipe(ofType(RECIPE_ACTIONS.uploadRecipeProfileImageToS3), switchMap((action) => {
        return this.httpService
            .post(mppEndpoints.uploadToS3, action.uploadImage)
            .pipe(map((response) => RECIPE_ACTIONS.uploadRecipeProfileImageToS3Success({
            uploadImageResponse: response,
        })), catchError$1((error) => of(RECIPE_ACTIONS.uploadRecipeProfileImageToS3Failure({ error }))));
    })));
    getImagesFromS3$ = createEffect(() => this.actions$.pipe(ofType(RECIPE_ACTIONS.getRecipeProfileImagesFromS3), switchMap((action) => {
        return this.httpService
            .post(mppEndpoints.getImagesFromS3, action.getImagesRequest)
            .pipe(map((response) => RECIPE_ACTIONS.getRecipeProfileImagesFromS3Success({
            getImagesResponse: response,
        })), catchError$1((error) => of(RECIPE_ACTIONS.getRecipeProfileImagesFromS3Failure({ error }))));
    })));
    addIngredientToRecipeRecipe$ = createEffect(() => this.actions$.pipe(ofType(RECIPE_ACTIONS.addIngredientToRecipeRecipe), withLatestFrom(this.store.select(selectRecipeState)), filter(([action, state]) => state &&
        state.entities &&
        state.entities[action.recipeId] !== undefined), switchMap(([action, state]) => {
        const body = {
            recipeDto: [
                { ...state.entities[action.recipeId] },
                { ...state.entities[action.ingredient.itemNumber] },
            ],
        };
        const timestamp = state.watermark ?? new Date().toISOString();
        return this.httpService
            .post(mppEndpoints.bulkUpdate, body)
            .pipe(switchMap((response) => [
            RECIPE_ACTIONS.addIngredientToRecipeRecipeSuccess({
                recipes: response,
            }),
            RECIPE_ACTIONS.setupRecipeDependencyGraph(),
        ]), catchError$1((error) => of(RECIPE_ACTIONS.addIngredientToRecipeRecipeFailure({ error }), RECIPE_ACTIONS.getMyChanges({ timestamp }))));
    })));
    addIngredientToRecipeProduct$ = createEffect(() => this.actions$.pipe(ofType(RECIPE_ACTIONS.addIngredientToRecipeProduct), withLatestFrom(this.store.select(selectRecipeState)), filter(([action, state]) => state &&
        state.entities &&
        state.entities[action.recipeId] !== undefined), switchMap(([action, state]) => {
        const body = {
            ...state.entities[action.recipeId],
        };
        const timestamp = state.watermark ?? new Date().toISOString();
        return this.httpService.post(mppEndpoints.recipe, body).pipe(switchMap((response) => [
            RECIPE_ACTIONS.addIngredientToRecipeProductSuccess({
                recipe: response,
            }),
            MPP_PRODUCT_ACTIONS.addMppProduct({
                mppProduct: action.mppProduct,
            }),
        ]), catchError$1((error) => of(RECIPE_ACTIONS.addIngredientToRecipeProductFailure({ error }), RECIPE_ACTIONS.getMyChanges({ timestamp }))));
    })));
    addIngredientToRecipeProductMultiple$ = createEffect(() => this.actions$.pipe(ofType(RECIPE_ACTIONS.addIngredientToRecipeProductMultiple), withLatestFrom(this.store.select(selectRecipeState)), filter(([action, state]) => state &&
        state.entities &&
        state.entities[action.recipeId] !== undefined), switchMap(([action, state]) => {
        const body = {
            ...state.entities[action.recipeId],
        };
        const timestamp = state.watermark ?? new Date().toISOString();
        return this.httpService.post(mppEndpoints.recipe, body).pipe(switchMap((response) => [
            RECIPE_ACTIONS.addIngredientToRecipeProductSuccess({
                recipe: response,
            }),
            MPP_PRODUCT_ACTIONS.addMppProducts({
                mppProducts: action.mppProducts,
            }),
        ]), catchError$1((error) => of(RECIPE_ACTIONS.addIngredientToRecipeProductFailure({ error }), RECIPE_ACTIONS.getMyChanges({ timestamp }))));
    })));
    addIngredientToRecipeNonUsfProductMultiple$ = createEffect(() => this.actions$.pipe(ofType(RECIPE_ACTIONS.addIngredientToRecipeNonUsfProductMultiple), withLatestFrom(this.store.select(selectRecipeState)), filter(([action, state]) => state &&
        state.entities &&
        state.entities[action.recipeId] !== undefined), switchMap(([action, state]) => {
        const body = {
            ...state.entities[action.recipeId],
        };
        const timestamp = state.watermark ?? new Date().toISOString();
        return this.httpService.post(mppEndpoints.recipe, body).pipe(switchMap((response) => [
            RECIPE_ACTIONS.addIngredientToRecipeNonUsfProductSuccess({
                recipe: response,
            }),
        ]), catchError$1((error) => of(RECIPE_ACTIONS.addIngredientToRecipeNonUsfProductFailure({
            error,
        }), RECIPE_ACTIONS.getMyChanges({ timestamp }))));
    })));
    updateCostIngredient$ = createEffect(() => this.actions$.pipe(ofType(RECIPE_ACTIONS.updateCostIngredient), switchMap((action) => {
        const body = action.costUpdateDto;
        return this.httpService
            .post(mppEndpoints.updateCost, body)
            .pipe(map((response) => RECIPE_ACTIONS.updateCostIngredientSuccess({
            mppObjectDto: response,
        })), catchError$1((error) => of(RECIPE_ACTIONS.updateCostIngredientFailure({ error }))));
    })));
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RecipeEffects, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RecipeEffects, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RecipeEffects, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/* eslint-disable @typescript-eslint/no-unused-vars */
class MPPProductEffects {
    actions$ = inject(Actions);
    store = inject(Store);
    /* prettier-ignore */
    httpService = inject(ToolsHttpClientService);
    getMppProducts$ = createEffect(() => this.actions$.pipe(ofType(MPP_PRODUCT_ACTIONS.getMppProducts), switchMap((action) => {
        return this.httpService
            .get(mppEndpoints.addMppProduct)
            .pipe(map((response) => MPP_PRODUCT_ACTIONS.getMppProductsSuccess({
            mppProducts: response,
        })), catchError$1((error) => of(MPP_PRODUCT_ACTIONS.getMppProductsFailure({ error }))));
    })));
    addMppProduct$ = createEffect(() => this.actions$.pipe(ofType(MPP_PRODUCT_ACTIONS.addMppProduct), switchMap((action) => {
        return this.httpService
            .post(mppEndpoints.addMppProduct, [action.mppProduct])
            .pipe(map((response) => MPP_PRODUCT_ACTIONS.addMppProductSuccess({
            mppProduct: response[0],
        })), catchError$1((error) => of(MPP_PRODUCT_ACTIONS.addMppProductFailure({ error }))));
    })));
    addMppProducts$ = createEffect(() => this.actions$.pipe(ofType(MPP_PRODUCT_ACTIONS.addMppProducts), switchMap((action) => {
        return this.httpService
            .post(mppEndpoints.addMppProduct, action.mppProducts)
            .pipe(map((response) => MPP_PRODUCT_ACTIONS.addMppProductsSuccess({
            mppProducts: response,
        })), catchError$1((error) => of(MPP_PRODUCT_ACTIONS.addMppProductsFailure({ error }))));
    })));
    deleteMppProduct$ = createEffect(() => this.actions$.pipe(ofType(MPP_PRODUCT_ACTIONS.deleteMppProduct), switchMap((action) => {
        return this.httpService
            .delete(mppEndpoints.addMppProduct, {
            body: [action.productNumber],
        })
            .pipe(map((response) => MPP_PRODUCT_ACTIONS.deleteMppProductSuccess({
            productNumber: action.productNumber,
        })), catchError$1((error) => of(MPP_PRODUCT_ACTIONS.deleteMppProductFailure({ error }))));
    })));
    updateMppProduct$ = createEffect(() => this.actions$.pipe(ofType(MPP_PRODUCT_ACTIONS.updateMppProduct), switchMap((action) => {
        return this.httpService
            .post(mppEndpoints.addMppProduct, [action.mppProduct])
            .pipe(map((response) => MPP_PRODUCT_ACTIONS.updateMppProductSuccess({
            mppProduct: response[0],
        })), catchError$1((error) => of(MPP_PRODUCT_ACTIONS.updateMppProductFailure({ error }))));
    })));
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MPPProductEffects, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MPPProductEffects, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MPPProductEffects, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
class NgRxToolsModule {
    ngrxToolsLibConfig;
    store;
    panAppState;
    constructor(ngrxToolsLibConfig, store, panAppState) {
        this.ngrxToolsLibConfig = ngrxToolsLibConfig;
        this.store = store;
        this.panAppState = panAppState;
    }
    static forRoot(ngrxToolsLibConfig, store, panAppState) {
        return {
            ngModule: NgRxToolsModule,
            providers: [
                {
                    provide: NGRX_TOOLS_LIB_CONFIG,
                    useValue: ngrxToolsLibConfig,
                },
                {
                    provide: APP_INITIALIZER,
                    useFactory: initializeToolsState,
                    deps: [MPPService],
                    multi: true,
                },
            ],
        };
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NgRxToolsModule, deps: [{ token: NGRX_TOOLS_LIB_CONFIG }, { token: i1$1.Store }, { token: i2.PanAppState }], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: NgRxToolsModule, imports: [i1$1.StoreFeatureModule, i1$1.StoreFeatureModule, i1$1.StoreFeatureModule, i3.EffectsFeatureModule, i3.EffectsFeatureModule, i3.EffectsFeatureModule] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NgRxToolsModule, providers: [
            ToolsHttpClientService,
            MppEffects,
            MPPService,
            RecipeEffects,
            MPPProductEffects,
        ], imports: [StoreModule.forFeature(MPP_KEY, mppReducer),
            StoreModule.forFeature(RECIPE_KEY, recipeReducer),
            StoreModule.forFeature(MPP_PRODUCT_KEY, mppProductReducer),
            EffectsModule.forFeature([MppEffects]),
            EffectsModule.forFeature([RecipeEffects]),
            EffectsModule.forFeature([MPPProductEffects])] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NgRxToolsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [
                        StoreModule.forFeature(MPP_KEY, mppReducer),
                        StoreModule.forFeature(RECIPE_KEY, recipeReducer),
                        StoreModule.forFeature(MPP_PRODUCT_KEY, mppProductReducer),
                        EffectsModule.forFeature([MppEffects]),
                        EffectsModule.forFeature([RecipeEffects]),
                        EffectsModule.forFeature([MPPProductEffects]),
                    ],
                    providers: [
                        ToolsHttpClientService,
                        MppEffects,
                        MPPService,
                        RecipeEffects,
                        MPPProductEffects,
                    ],
                    exports: [],
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [NGRX_TOOLS_LIB_CONFIG]
                }] }, { type: i1$1.Store }, { type: i2.PanAppState }]; } });
function initializeToolsState(toolsState) {
    const state = () => toolsState.initialize();
    return state;
}

const ANALYTICS_ACTIONS = {
    clickMPPEntryPoint: createAction('[NgRxMPP - Analytics] navigate to MPP landing', props()),
    enterLanding: createAction('[NgRxMPP - Analytics] setup subMenu for landing page', props()),
    enterRecipe: createAction('[NgRxMPP - Analytics] setup subMenu for recipe page', props()),
    createRecipe: createAction('[NgRxMPP - Analytics] create recipe action', props()),
    copyRecipe: createAction('[NgRxMPP - Analytics] copy recipe action', props()),
    deleteRecipe: createAction('[NgRxMPP - Analytics] delete recipe action', props()),
    archiveRecipe: createAction('[NgRxMPP - Analytics] archive recipe action', props()),
    unArchiveRecipe: createAction('[NgRxMPP - Analytics] unarchive recipe action', props()),
    clickRecipeButton: createAction('[NgRxMPP - Analytics] click recipe button', props()),
    clickCreateNewRecipeButton: createAction('[NgRxMPP - Analytics] click create new recipe button', props()),
    clickNavBarRecipeButton: createAction('[NgRxMPP - Analytics] click navigation bar recipe button', props()),
};

const selectMPPState = createFeatureSelector(MPP_KEY);
const getAllMenuItems = () => createSelector(selectMPPState, (promotions) => Object.values(promotions.entities));
const getMPPBaseViewModel = createSelector(selectMPPState, (mppState) => {
    return {
        images: mppState.images,
        aiTile: mppState.aiTile,
        subMenuItems: mppState.subMenuItems,
    };
});
const getLastVisited = createSelector(selectMPPState, (mppState) => mppState.lastVisited);
const { selectAll: selectAll } = mppAdapter.getSelectors(selectMPPState);

/* eslint-disable max-len */
/* eslint-disable no-shadow */
var MPPTracingConstants;
(function (MPPTracingConstants) {
    //TracingContext
    MPPTracingConstants["clickMPPEntryPoint"] = "clickMPPEntryPoint";
    MPPTracingConstants["enterDashboard"] = "enterMPPDashboard";
    MPPTracingConstants["enterRecipesPage"] = "enterRecipeListing";
    MPPTracingConstants["getRecipes"] = "getRecipes";
    MPPTracingConstants["deleteRecipes"] = "deleteRecipes";
    MPPTracingConstants["archiveRecipes"] = "archiveRecipes";
    MPPTracingConstants["createRecipe"] = "createRecipe";
    MPPTracingConstants["copyRecipes"] = "copyRecipes";
    MPPTracingConstants["uploadImage"] = "uploadImage";
    MPPTracingConstants["getMyChanges"] = "getMyChanges";
    MPPTracingConstants["enterRecipeDetailPage"] = "enterRecipeDetailPage";
    //Event
    MPPTracingConstants["clickMPPEntryPointEvent"] = "navigate to mpp dashboard";
    MPPTracingConstants["enterDashboardEvent"] = "enter mpp dashboard";
    MPPTracingConstants["enterRecipesPageEvent"] = "enter recipe listing page";
    MPPTracingConstants["getRecipesEvent"] = "get recipes";
    MPPTracingConstants["deleteRecipesEvent"] = "delete recipes";
    MPPTracingConstants["archiveRecipesEvent"] = "archive recipes";
    MPPTracingConstants["createRecipeEvent"] = "create recipe";
    MPPTracingConstants["copyRecipesEvent"] = "copy recipes";
    MPPTracingConstants["uploadImageEvent"] = "upload recipe profile image";
    MPPTracingConstants["getMyChangesEvent"] = "send timestamp to check changes";
    MPPTracingConstants["enterRecipeDetailPageEvent"] = "enter recipe detail page";
    //Span Names
    MPPTracingConstants["clickMPPEntryPointSpan"] = "Navigate To MPP Dashboard";
    MPPTracingConstants["enterDashboardSpan"] = "Enter MPP Dashboard";
    MPPTracingConstants["enterRecipesPageSpan"] = "Enter Recipe Listing Page";
    MPPTracingConstants["getRecipesSpan"] = "Get Recipes";
    MPPTracingConstants["deleteRecipesSpan"] = "Delete Recipes";
    MPPTracingConstants["archiveRecipesSpan"] = "Archive Recipes";
    MPPTracingConstants["createRecipeSpan"] = "Create Recipe";
    MPPTracingConstants["copyRecipesSpan"] = "Copy Recipes";
    MPPTracingConstants["uploadImageSpan"] = "Upload Recipe Profile Image";
    MPPTracingConstants["enterRecipeDetailPageSpan"] = "Enter Recipe Detail Page";
    // Descriptions
    MPPTracingConstants["eventSuccess"] = " success";
    MPPTracingConstants["eventFailure"] = " failure";
    MPPTracingConstants["spanSuccess"] = " Success";
    MPPTracingConstants["spanFailure"] = " Failure";
})(MPPTracingConstants || (MPPTracingConstants = {}));

/* eslint-disable max-len */
/* eslint-disable no-shadow */
var MPPAnalyticsConstants;
(function (MPPAnalyticsConstants) {
    // Capabilities
    MPPAnalyticsConstants["capability"] = "MPP";
    // Event Names
    MPPAnalyticsConstants["buttonClick"] = "button click";
    MPPAnalyticsConstants["pageLoaded"] = "page loaded";
    MPPAnalyticsConstants["recipeActionEvent"] = "manage recipe";
    // Page Names
    MPPAnalyticsConstants["dashboardPage"] = "us foods:r4:mpp:dashboard";
    MPPAnalyticsConstants["recipePage"] = "us foods:r4:mpp:recipes";
    // Descriptions
    MPPAnalyticsConstants["buttonNameMPP"] = "menu profit pro";
    MPPAnalyticsConstants["buttonNameRecipes"] = "mpp:recipes";
    MPPAnalyticsConstants["buttonNameAddNew"] = "mpp:create new";
    //local Nav
    MPPAnalyticsConstants["navBarRecipesButton"] = "mpp:nav:recipes";
    //Action Types
    MPPAnalyticsConstants["createRecipe"] = "create";
    MPPAnalyticsConstants["copyRecipe"] = "copy";
    MPPAnalyticsConstants["deleteRecipe"] = "delete";
    MPPAnalyticsConstants["archiveRecipe"] = "archive";
    MPPAnalyticsConstants["unArchiveRecipe"] = "unarchive";
})(MPPAnalyticsConstants || (MPPAnalyticsConstants = {}));

var LastVisitedType;
(function (LastVisitedType) {
    LastVisitedType["RECIPE"] = "recipe";
    LastVisitedType["EVENT_MENU"] = "eventMenu";
    LastVisitedType["MENU_ITEM"] = "menuItem";
})(LastVisitedType || (LastVisitedType = {}));

const buttonClickTransformer = (tracking) => ({
    event: tracking.data.event,
    capability: tracking.data.capability,
    button: {
        buttonName: tracking.data.buttonName,
    },
});
const pageLoadTransformer = (tracking) => ({
    page: {
        pageName: tracking.data.pageName,
    },
    event: tracking.data.event,
    capability: tracking.data.capability,
});
const actionTypeTransformer = (tracking) => ({
    actiontype: tracking.data.actionType,
    event: tracking.data.event,
    capability: tracking.data.capability,
});

const baseMPPTransform = (tracking) => ({
    ...baseTransform(tracking),
});
const baseTransform = (tracking) => {
    let result = {
        event: tracking.data.attributes.event,
        spanName: tracking.data.attributes.spanName,
        traceContext: tracking.data.traceContext,
        isStartOfTrace: tracking.data.isStartOfTrace,
        isEndOfTrace: tracking.data.isEndOfTrace,
    };
    if (tracking.data.attributes?.error) {
        result = {
            ...result,
            http: {
                statusCode: tracking.data.attributes.error.status,
                statusText: tracking.data.attributes.error.message,
            },
        };
    }
    return result;
};

// module

/**
 * Generated bundle index. Do not edit.
 */

export { ANALYTICS_ACTIONS, INGREDIENT_OPTIONS, LastVisitedType, MPPAnalyticsConstants, MPPService, MPPTracingConstants, MPP_ACTIONS, MPP_KEY, MPP_PRODUCT_ACTIONS, MPP_PRODUCT_KEY, NgRxToolsModule, RECIPE_ACTIONS, RECIPE_KEY, RecipeDetailTabs, RecipeSortOptions, SortDirections, actionTypeTransformer, baseMPPTransform, buttonClickTransformer, getAllMPPProducts, getAllRecipeFilters, getAllRecipes, getCopiedRecipes, getFilteredRecipeDataForSearchBasedOnBlacklist, getIngreidentSearchKey, getIsRecipeLoaded, getLastVisited, getMPPBaseViewModel, getRecipeByIdFromState, getRecipeDetails, getRecipeSortableHeaders, getWatermark, initialRecipesSort, initializeToolsState, mppAdapter, mppProductAdapter, mppProductReducer, mppReducer, pageLoadTransformer, recipeAdapter, recipeHeaders, recipeReducer, selectBaseCalculations, selectLastRecipeCustomer, selectLastSelectedIngredient, selectRecipeImageSrc, selectRecipeImagesLoaded };
